import React, {useEffect} from "react"
import {observer} from "mobx-react"
import Grid from "@material-ui/core/Grid"
import MomentUtils from "@date-io/moment"
import {MuiPickersUtilsProvider, KeyboardDateTimePicker} from "@material-ui/pickers"
import {FormattedMessage} from "react-intl"

import "./xsDateTimePicker.less"

function XsDateTimePicker(props) {
	const {field} = props

	const bindedField = field.bind()

	// V rules fieldu musi byt date inak ulozi aj nevalidny date
	useEffect(() => {
		const rules = props.field.get("rules")
		if (isSafe(rules) && !rules.includes("date")) {
			props.field.set("rules", rules + (rules.length > 0 ? "|date" : "date"))
		}
	}, [])

	const handleDateChange = (date, value) => {
		props.field.set("value", date)
		if (isSafe(props.onChange) && typeof props.onChange === "function") {
			props.onChange(date, value)
		}
	}

	const labelJSX =
		isSafe(field.get("rules")) && field.get("rules").includes("required") ? (
			<span className="xs-input-label xs-required">{bindedField.label} *</span>
		) : (
			<span className="xs-optional">{bindedField.label}</span>
		)

	return (
		<MuiPickersUtilsProvider utils={MomentUtils}>
			<Grid container justify="space-around">
				<KeyboardDateTimePicker
					autoOk
					fullWidth
					disabled={props.disabled}
					inputVariant="outlined"
					variant="inline"
					size="small"
					format="DD.MM.yyyy HH:mm"
					// margin="normal"
					label={labelJSX}
					value={props.field.get("value")}
					onChange={handleDateChange}
					InputProps={{className: "datepickerInput"}}
					InputAdornmentProps={{position: "start"}}
					KeyboardButtonProps={{
						"aria-label": "change date"
					}}
					invalidDateMessage={<FormattedMessage id="Common.invalidDate" />}
					required={props.required}
				/>
			</Grid>
		</MuiPickersUtilsProvider>
	)
}
export default observer(XsDateTimePicker)

